import "./Certification.css";

function CertificationCardLoading() {
  return <div className="shimmer cert-skeleton" />;
}

export default CertificationCardLoading;
